<template>
	<popup-dialog :popup-active="popupStatus" :class="overPopupClassname">
		<div :class="wrapperClassname" class="confirm">
			<loading-el v-if="loading"></loading-el>
			<i v-if="showCloseButton" @click="closeButton" class="fas fa-times confirm-close"></i>
			<div v-if="content" class="confirm__content" v-html="content"></div>
			<div v-if="showButtons" class="button-wrapper confirm__button-wrapper">
				<div v-if="showCancelButton" :class="cancelButtonClassname" @click="actionCancel" class="button confirm__button">
					<i v-if="cancelButtonIcon" :class="cancelButtonIcon" class="fas mr--9"></i>
					<span>{{cancelButton || cancelButtonDefault}}</span>
				</div>
				<div v-if="showConfirmButton" :class="confirmButtonClassname" @click="actionConfirm" class="button confirm__button">
					<i v-if="confirmButtonIcon" :class="confirmButtonIcon" class="fas mr--9"></i>
					<span>{{confirmButton || confirmButtonDefault}}</span>
				</div>
			</div>
      <slot></slot>
			<slot name="actions"></slot>
		</div>
	</popup-dialog>
</template>

<script>
import PopupDialog from '@/components/ui/popup/PopupDialog';
import {computed} from 'vue';
import LoadingEl from '@/components/ui/loading/LoadingEl.vue'
import {useI18n} from "vue-i18n";
export default {
	components:{
		LoadingEl,
		PopupDialog,
	},
	props: {
		popupStatus:{
			type: Boolean,
			default: false
		},
		content:{
			type: String,
      default: ''
		},
		loading: {
			type: Boolean,
			default: false,
		},
		confirmButton: {
			type: String,
			default: ''
		},
		confirmButtonIcon: {
			type: String,
			default: 'fa-trash'
		},
		confirmButtonClassname: {
			type: String,
			default: ''
		},
		showButtons: {
			type: Boolean,
			default: true,
		},
		showConfirmButton: {
			type: Boolean,
			default: true
		},
		cancelButton: {
			type: String,
			default: ''
		},
		cancelButtonIcon: {
			type: String,
			default: ''
		},
		cancelButtonClassname: {
			type: String,
			default: 'bg--blue-grey color--black'
		},
		showCancelButton: {
			type: Boolean,
			default: true
		},
		showCloseButton: {
			type: Boolean,
			default: true,
		},
		closeButtonAction: {
			type: Boolean,
			default: false
		},
		overPopup: {
			type: Boolean,
			default: true
		},
		wrapperClassname: {
			type: String,
			default: ''
		}
	},
	setup(props, {emit}) {
		const { t } = useI18n();
		
		const cancelButtonDefault = computed(() => t('popup.confirm.stopMe'));
		const confirmButtonDefault = computed(() => t('popup.confirm.sure'));
		
		function actionCancel(){
			emit('actionCancel');
		}
		function actionConfirm(){
			emit('actionConfirm');
		}
		function closeButton(){
			if(props.closeButtonAction){
				emit('closeAction');
				return;
			}
			actionCancel();
		}
		
		const overPopupClassname = computed(() => props.overPopup ? 'popup-window' : '');
		
		return {
			t,
			cancelButtonDefault,
			confirmButtonDefault,
			actionCancel,
			actionConfirm,
			closeButton,
			overPopupClassname,
		}
	}
}
</script>

<style lang="scss">

</style>
